<template>
    <!-- Page Header-->
    <header class="section page-header">
        <!-- RD Navbar-->
        <div class="rd-navbar-wrap">
            <nav class="rd-navbar rd-navbar-modern" data-layout="rd-navbar-fixed" data-sm-layout="rd-navbar-fixed" data-md-layout="rd-navbar-fixed" data-md-device-layout="rd-navbar-fixed" data-lg-layout="rd-navbar-static" data-lg-device-layout="rd-navbar-fixed" data-xl-layout="rd-navbar-static" data-xl-device-layout="rd-navbar-static" data-xxl-layout="rd-navbar-static" data-xxl-device-layout="rd-navbar-static" data-lg-stick-up-offset="100px" data-xl-stick-up-offset="120px" data-xxl-stick-up-offset="140px" data-lg-stick-up="true" data-xl-stick-up="true" data-xxl-stick-up="true">
            <div class="rd-navbar-collapse-toggle rd-navbar-fixed-element-1" data-rd-navbar-toggle=".rd-navbar-collapse"><span></span></div>
            <div class="rd-navbar-aside-outer">
                <div class="rd-navbar-aside">
                <div class="rd-navbar-collapse">
                    <div class="contacts-ruth">
                    <div class="unit unit-spacing-xs-2 align-items-center">
                        <div class="unit-left"><span class="icon linearicons-map-marker"></span></div>
                        <div class="unit-body"><a href="#">Shop 16, 211 Leakes Rd<br/>Truganina VIC 3029</a></div>
                    </div>
                    </div><a class="button button-sm button-icon button-icon-left button-default-outline-3 button-zakaria" href="#"><span class="icon mdi mdi-email-outline"></span>Get in touch</a>
                </div>
                <!-- RD Navbar Panel-->
                <div class="rd-navbar-panel">
                    <!-- RD Navbar Toggle-->
                    <button class="rd-navbar-toggle" data-rd-navbar-toggle=".rd-navbar-nav-wrap"><span></span></button>
                    <!-- RD Navbar Brand-->
                    <div class="rd-navbar-brand"><router-link class="brand" to="/"><img class="brand-logo-dark" src="/assets/images/Logo_Horizontal.jpg" alt="" srcset="/assets/images/Logo_Horizontal.jpg 2x"/><img class="brand-logo-light" src="/assets/images/logo_2.png" alt="" srcset="/assets/images/logo_2.png 2x"/></router-link>
                    </div>
                </div>
                <div class="rd-navbar-button"><router-link class="button button-sm button-icon button-icon-left button-default-outline-3 button-zakaria" to="/contact-us"><span class="icon mdi mdi-email-outline"></span>Get in touch</router-link></div>
                </div>
            </div>
            <div class="rd-navbar-main-outer">
                <div class="rd-navbar-main">
                <div class="rd-navbar-nav-wrap">
                    <!-- RD Navbar Nav-->                     
                    <ul class="rd-navbar-nav">
                    <li class="rd-nav-item" :class="{ active: $route.name === 'index' }"><a class="rd-nav-link" href="/">Home</a></li>
                    <li class="rd-nav-item" :class="{ active: $route.name === 'our-menu' || $route.name === 'show-product' }"><a class="rd-nav-link" href="/our-menu">Our Menu</a></li>
                    <li class="rd-nav-item" :class="{ active: $route.name === 'custom-cake-category' || $route.name === 'custom-cake' }"><a class="rd-nav-link" href="/custom-cake-category">Custom Cakes</a></li>
                    <li class="rd-nav-item" :class="{ active: $route.name === 'about-us' }"><a class="rd-nav-link" href="/about-us">About Us</a></li>
                    <li class="rd-nav-item" :class="{ active: $route.name === 'contact-us' }"><a class="rd-nav-link" href="/contact-us">Contact Us</a></li>
                    <!-- <li class="rd-nav-item"><router-link class="rd-nav-link" to="/careers">Careers</router-link></li> -->
                    <li v-if="!isAuthenticated()" class="rd-nav-item" :class="{ active: $route.name === 'login' || $route.name === 'register' }"><a class="rd-nav-link" href="#">Auth</a>
                        <ul class="rd-menu rd-navbar-dropdown">
                            <li class="rd-dropdown-item"><a class="rd-dropdown-link" href="/login">Login</a></li>
                            <li class="rd-dropdown-item"><a class="rd-dropdown-link" href="/register">Register</a></li>
                        </ul>
                    </li>                    
                    <li v-if="isAuthenticated()" class="rd-nav-item"><a class="rd-nav-link" href="/home">My Account</a>
                        <ul class="rd-menu rd-navbar-dropdown">                            
                            <li class="rd-dropdown-item"><a href="javascript:void(0);" class="rd-dropdown-link" @click="handleLogout">Logout</a></li>
                        </ul>
                    </li>
                    </ul>
                </div>
                <div class="rd-navbar-main-element">
                    <!-- RD Navbar Search-->
                    <!-- <div class="rd-navbar-search rd-navbar-search-3">
                    <button class="rd-navbar-search-toggle rd-navbar-fixed-element-3" data-rd-navbar-toggle=".rd-navbar-search"><span></span></button>
                    <form class="rd-search" action="#" data-search-live="rd-search-results-live" method="GET">
                        <div class="form-wrap">
                        <label class="form-label" for="rd-navbar-search-form-input">Search...</label>
                        <input class="rd-navbar-search-form-input form-input" id="rd-navbar-search-form-input" type="text" name="s" autocomplete="off"/>
                        <div class="rd-search-results-live" id="rd-search-results-live"></div>
                        <button class="rd-search-form-submit fl-bigmug-line-search74" type="submit"></button>
                        </div>
                    </form>
                    </div> -->
                    <!-- RD Navbar Basket-->
                    <CartComponent />
                </div>
                </div>
            </div>
            </nav>
        </div>
    </header>

</template>
<script setup>
import CartComponent from '../common/CartComponent.vue';
import { useAuth } from '@/composables/useAuth'
import { useAuthStore } from '@/stores/authStore';
import { onMounted, nextTick, watch } from 'vue';
import { useRouter } from 'vue-router';

const authStore = useAuthStore()
const router = useRouter()
const { isAuthenticated, logout } = useAuth()

async function handleLogout() {    
    await logout()              // clean state & call API
    router.push({ name: 'login' }).then(() => window.location.reload())
}

onMounted(async () => {
   await nextTick()    

   const scriptId = 'script-js-script'

   // Check if the script already exists
   const existingScript = document.getElementById(scriptId)

   if (existingScript) {
      // Replace it: remove and re-add
      existingScript.remove()
   }

   // Create and append a fresh script
   const newScript = document.createElement('script')
   newScript.src = '/assets/js/script.js'
   newScript.id = scriptId
   document.body.appendChild(newScript) 
   console.log(window.plugins?.rdNavbar)
   if (window.plugins?.rdNavbar) {
    window.plugins.rdNavbar.RDNavbar({
      anchorNav: true,
      stickUpClone: false,
      responsive: true,
    })
  }
   
})

// Watch user login
watch(
  () => authStore.user,
  (newUser) => {
    if (newUser) {
      // User logged in — re-init RDNavbar
      setTimeout(() => {
        if (window.plugins?.rdNavbar) {
          window.plugins.rdNavbar.RDNavbar({
            anchorNav: true,
            stickUpClone: false,
            responsive: true,
          })
        }
      }, 50) // slight delay to ensure DOM updated
    }
  }
)


</script>
